/**
 * Claude API wrapper with token usage tracking.
 * Replaces direct fetch() calls to api.anthropic.com.
 *
 * Usage:
 *   import { callClaude } from '../lib/claude';
 *   const data = await callClaude({ model, max_tokens, system, messages }, 'quiz-check');
 *   // data.content[0].text = the response text
 */

const ANTHROPIC_API = 'https://api.anthropic.com/v1/messages';
const TOKEN_LOG_URL = 'https://crm.buteyko.fitness/api/token-log';

interface ClaudeRequest {
  model: string;
  max_tokens: number;
  system?: string;
  messages: Array<{ role: string; content: string }>;
}

export async function callClaude(request: ClaudeRequest, action?: string): Promise<any> {
  const apiKey = process.env.REACT_APP_ANTHROPIC_API_KEY || '';

  const response = await fetch(ANTHROPIC_API, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
      'anthropic-version': '2023-06-01',
      'anthropic-dangerous-direct-browser-access': 'true',
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`Claude API error: ${response.status}`);
  }

  const data = await response.json();

  // Log token usage in the background (fire-and-forget)
  if (data.usage) {
    fetch(TOKEN_LOG_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        project: 'adriana-app',
        model: data.model || request.model,
        action: action || 'unknown',
        input_tokens: data.usage.input_tokens || 0,
        output_tokens: data.usage.output_tokens || 0,
        cache_read_tokens: data.usage.cache_read_input_tokens || 0,
        cache_creation_tokens: data.usage.cache_creation_input_tokens || 0,
      }),
    }).catch(() => {}); // silently ignore logging errors
  }

  return data;
}
